import React from 'react';
import ReactDOM from 'react-dom';
import { Admin } from './admin';

document.querySelectorAll(".admin-page__container").forEach((elem) => {

    ReactDOM.render(
        <Admin />
    , elem);
});
